import * as React from 'react';
import b_ from 'b_';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PulseLoading from 'shared/components/PulseLoading';
import Stock from 'components/Stock';
import { actions } from '../../../StockFilters/actions';
import { StockSearchNoResult } from '../StockSearchNoResult';
import { FetchMoreButton } from '../FetchMoreButton';
import { useList } from './hooks';

import './index.scss';

const b = b_.with('stocks-list-content');

export const Content: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const resetFilter = () => dispatch(actions.reset());

  const { loading, fetchMore, stocks, hasMore, nextPortion, totalElements } = useList();

  if (!stocks?.length) {
    if (loading) {
      return <PulseLoading className={b('loader')} big />;
    }

    return <StockSearchNoResult handler={resetFilter} />;
  }

  return (
    <div className={b({ loading })}>
      {(stocks || []).map((stock) => (
        <Stock key={stock.id} stock={stock} />
      ))}

      {hasMore && (
        <FetchMoreButton loading={loading} onClick={fetchMore}>
          {t('Show {{portion}} from {{total}}', {
            portion: nextPortion,
            total: totalElements,
          })}
        </FetchMoreButton>
      )}
    </div>
  );
};
